import app from 'flarum/forum/app';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Link from "flarum/common/components/Link";
import avatar from "flarum/common/helpers/avatar";
import sortTags from 'flarum/tags/utils/sortTags';
import Widget from 'flarum/extensions/afrux-forum-widgets-core/common/components/Widget';

export default class IndexDisscussionWidget extends Widget {
  oninit(vnode) {
    super.oninit(vnode);
  }

  className() {
    return  `${this.attrs.title}-widget ` + 'ruko-widget';
  }

  title() {
    return  app.translator.trans('acme-ruko.forum.widget.index_discussions', {slug: this.attrs.title});
  }

  content() {
    const {loading, discussion} = this.attrs;
    if (loading) {
      return <LoadingIndicator />;
    }
    return (
      <div className="Widget-SectionList">
        <ul className="section-ul">
          {discussion.map((disc) => {
            const user = disc.user();
            const tags = disc.tags();
            const allTags = sortTags(tags);
            return (
              <li class="section-box index-widget">
                <Link className="section-box-discussion" href={app.route.discussion(disc)} alt={disc.title()}>
                  {disc.title()}
                </Link>
                <div className="index-widget-user">
                  <Link className="author text" href={user ? app.route.user(user) : '#'}>
                    {avatar(user || null)}
                    {app.translator.trans('core.forum.discussion_list.user', { user: user })}
                  </Link>
                  <span>/</span>
                  <span className="tag text">
                    {disc.productName() || allTags[allTags.length - 1].name()}
                  </span>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}
